// extracted by mini-css-extract-plugin
export default {"row":"createCompetition_row__sjJAW","col":"createCompetition_col__+fB6i","card":"createCompetition_card__WH8o8"};